import extensions from "_src/engine/extensions";
import objFactory from "_src/engine/factories/object";
import primitiveFactory from "_src/engine/factories/primitive";
import FrameBuffer from "_src/engine/framebuffer";
import { primitiveType, blendFactor, pixelBufferType, RBIntFormat, attachmentId } from "_src/engine/constants";

import Pass from "_src/render_graph/pass";
import resourceManager from "_src/render_graph/resource_manager";
import CopyShader from "_src/shaders/copy/copy";

export default class TransformPass extends Pass {

  constructor(attachmentsStorage, cameraMain, cameraScreen) {

    super(attachmentsStorage);

    this.init(cameraMain, cameraScreen);

  }

  init(cameraMain, cameraScreen) {

    const copyScene = this._addScene(cameraScreen);
    const mainScene = this._addScene(cameraMain);

    const copyShader = new CopyShader({transparent : true});
    copyShader.setSourceBlendFactor(blendFactor.ONE);

    const copyScreenPlane = objFactory.createDrawable(copyShader);
    copyScreenPlane.addGeometryChunk(primitiveFactory.create(primitiveType.SCREEN_QUAD));
    copyScene.add(copyScreenPlane);

    mainScene.clearedDepth = false;
    mainScene.clearedColor = false;

  }

  update() {

    const copyScene = this.getMainScene();
    const mainScene = this.getSecondScene();

    const width = copyScene.camera.viewport[2];
    const height = copyScene.camera.viewport[3];

    const mainFramebuffer = this.initFramebuffer(width, height);

    if (extensions.isMultisamplingSupported()) {

      const mSamplingBuffer = this.initResolveFramebuffer(width, height);

      copyScene.setFramebuffer(mSamplingBuffer);
      mainScene.setFramebuffer(mSamplingBuffer);
      mainScene.setResolvedBuffer(mainFramebuffer);

    } else {

      copyScene.setFramebuffer(mainFramebuffer);
      mainScene.setFramebuffer(mainFramebuffer);

      copyScene.setEnabled(false);
      mainScene.clearedDepth = true;

    }

  }

  initFramebuffer(width, height) {

    const copyTexture = this.attachmentsStorage[attachmentId.OUTPUT_COLOR_TEXTURE];
    // NOTE: we have to init one more render buffer because of renderbufferStorageMultisample
    // doesn't support the DEPTH_STENCIL internal format. But it supports DEPTH24_STENCIL8 missing in webgl 1.0
    const format = RBIntFormat.DS;
    const depthBuffer = resourceManager.initBuffer(pixelBufferType.RB_DEPTH, { width, height, format });

    const copyScene = this.getMainScene();
    const copyScreenPlane = this.getScreenQuad(copyScene);
    copyScreenPlane.setTexture(copyTexture, 0);

    const mainFramebuffer = new FrameBuffer([copyTexture], depthBuffer);

    return mainFramebuffer;

  }

  initResolveFramebuffer(width, height) {

    const samples = 4;
    const format = RBIntFormat.R8G8B8A8;
    const depthFormat = RBIntFormat.DS;

    const mSamplingTexture = resourceManager.initBuffer(pixelBufferType.RB_RGBA,
        { width, height, format, samples });
    const mSamplingDepthBuffer = resourceManager.initBuffer(pixelBufferType.RB_DEPTH,
        { width, height, format: depthFormat, samples });

    return new FrameBuffer([mSamplingTexture], mSamplingDepthBuffer);

  }

}
